import { StatusBadge } from '@/components/badges';
import { DataSourceIcon } from '@/lib';
import { DataSource, DataSourceCodeConfig, DataSourceIDEnum, EDataSourceCategory, EDataSourceStatus } from '@/models/dataSource';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

type ActivationStatusProps = {
  dataSource?: DataSource;
};

export const ActivationStatus: FunctionComponent<ActivationStatusProps> = ({ dataSource }) => {
  const { t } = useTranslation('data_sources');
  const id = dataSource.type.id as DataSourceIDEnum;
  const type = t(`catalog.${id}.title`);

  return (
    <div className='flex w-full rounded bg-gray-50'>
      <div className='flex-col whitespace-nowrap py-1 text-sm font-medium text-gray-900 '>
        <div className=' flex space-x-3 px-2 py-1 sm:px-3'>
          <div className='shrink-0'>
            <div className='flex size-14 flex-wrap place-content-center rounded-lg'>
              <DataSourceIcon type={id} className='h-10' />
            </div>
          </div>
          <div className='flex flex-wrap content-center'>
            <div className='flex-col'>
              <p className='text-sm font-medium text-gray-900'>{dataSource?.name}</p>
              {dataSource?.type.category === EDataSourceCategory.CODE ? (
                <p className='text-sm font-normal text-gray-500'>{`${type} • ${(dataSource.configuration as DataSourceCodeConfig).url}`} </p>
              ) : (
                <p className='text-sm font-normal text-gray-500'>{`${type}`} </p>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className='m-auto flex whitespace-nowrap px-2 py-4 text-sm font-medium text-gray-900'>
        <StatusBadge status={dataSource?.status || EDataSourceStatus.PENDING} />
      </div>
    </div>
  );
};
